// Define Element image-with-feature-tabs
if (!window.customElements.get("image-with-feature-tabs")) {
  class ImageWithFeatureTabs extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("change", this.onTabChange);

      this.images = Array.from(
        this.querySelectorAll(".image-with-text__media-inner"),
      );
      this.tabs = Array.from(
        this.querySelectorAll(".feature-tabs__tab-content"),
      );

      // Play video on the first tab
      setTimeout(() => {
        this.updateVideosWithTabName(this.tabs[0].dataset.tab)
      });
    }

    onTabChange(event) {
      const tabName = event.target.id;
      this.switchTab(tabName);
      this.updateImageWithTabName(tabName);
      this.updateVideosWithTabName(tabName);
    }

    updateImageWithTabName(tabName) {
      const selesctedImage = this.images.find(
        (image) => image.dataset.tab == tabName,
      );

      for (const image of this.images) {
        image.style.display =
          image == selesctedImage ||
          (!selesctedImage && image.dataset.tab == "default")
            ? "block"
            : "none";
      }
    }
    updateVideosWithTabName(tabName) {
      // Stop videos when tab is changed and play only the selected one
      const videos = this.querySelectorAll("video");
      for (const video of videos) {
        const videoTab = video.closest(".image-with-text__media-inner");
        if (videoTab.dataset.tab == tabName) {
          video.play();
        } else {
          video.pause();
        }
      }
    }

    switchTab(tabName) {
      const selectedTab = this.tabs.find((tab) => tab.dataset.tab == tabName);
      for (const tab of this.tabs) {
        tab.style.display = tab == selectedTab ? "block" : "none";
      }
    }
  }

  customElements.define("image-with-feature-tabs", ImageWithFeatureTabs);
}
//(() => {
//tabs.addEventListener("change", (event) => {
//const tabContent = tabs.querySelector(
//`.feature-tabs__tab-content[data-tab="${event.target.id}"]`,
//);
//const image = tabs.querySelector(
//`.image-with-text__media-inner[data-tab="${event.target.id}"]`,
//);
//document
//.querySelectorAll(".feature-tabs__tab-content")
//.forEach((content) => {
//content.style.display = content == tabContent ? "block" : "none";
//});
//document
//.querySelectorAll(".image-with-text__media-inner")
//.forEach((content) => {
//if (image) {
//content.style.display = content == image ? "block" : "none";
//} else {
//content.style.display =
//content.dataset.tab == "default" ? "block" : "none";
//}
//});
//});
//})();
